import { BillingApiClient } from '../../services'

export async function getLegacyBillingReadonly(workspaceId: string): Promise<boolean> {
  const info = await BillingApiClient.getBillingInfo(workspaceId)
  return info.billingReadonly
}
